import React, { useEffect, useState } from "react";
import { Table, Container, Button, Modal, Col, Row, Image } from "react-bootstrap";
import GetProducts from "../services/product.services";
import "../styles/listproducts.css";
import Cookies from "universal-cookie";
import { FaPaperPlane, FaEdit, FaTrash, FaRegSave } from "react-icons/fa";

function ListProducts() {
  const cookies = new Cookies();
  const token = cookies.get("token");
  const [products, setProducts] = useState([]);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [showResendModal, setShowResendModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [filteredProducts, setFilteredProducts] = useState([]);

  // Close Modals
  const closeDeleteModal = () => setShowDeleteModal(false);
  const closeDetailsModal = () => setShowDetailsModal(false);
  const closeResendModal = () => setShowResendModal(false);

  // Show Modals
  const handleShowDeleteModal = (productId) => {
    setSelectedProductId(productId);
    setShowDeleteModal(true);
  };

  const handleShowDetailsModal = (product) => {
    console.log(`Estes es el ${product}`)
    setSelectedProduct(product);
    setSelectedProductId(product._id);
    setShowDetailsModal(true);
  };

  const handleShowResendModal = (product) => {
    setSelectedProduct(product);
    setShowResendModal(true);
  };

  const handleSearchInputChange = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchQuery(value);
    setFilteredProducts(
      products.filter(
        (product) =>
          product.name?.toLowerCase().includes(value) ||
          product.description?.toLowerCase().includes(value) ||
          product.reference?.toLowerCase().includes(value) ||
          product.brand?.toLowerCase().includes(value)
      )
    );
  };

  const fetchProducts = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
    };
    try {
      const response = await fetch(`${GetProducts.RUTA_API_Products}`, requestOptions);
      if (!response.ok) {
        const errorMessage = await response.text();
        console.error("Error fetching products:", errorMessage);
        throw new Error("Error fetching products");
      }

      const data = await response.json();
      setProducts(data);
      setFilteredProducts(data);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const removeProductFromList = (productId) => {
    setProducts((prev) => prev.filter((product) => product._id !== productId));
    setFilteredProducts((prev) =>
      prev.filter((product) => product._id !== productId)
    );
  };

  const deleteProduct = async () => {
    try {
      const response = await fetch(
        `http://localhost:3000/products/${selectedProductId}`,
        {
          method: "DELETE",
        }
      );

      if (response.ok) {
        removeProductFromList(selectedProductId);
        closeDeleteModal();
      } else {
        console.error("Error deleting product:", response.status, response.statusText);
      }
    } catch (error) {
      console.error("Error deleting product:", error);
    }
  };

  const formatCurrency = (value) => {
    if (typeof value === "number") {
      return value.toLocaleString("es-CO", {
        style: "currency",
        currency: "COP",
        minimumFractionDigits: 0,
      });
    }
    return "";
  };

  return (
    <Container fluid className="product-list">
      <h2>Lista de Productos</h2>
      <input
        type="text"
        value={searchQuery}
        onChange={handleSearchInputChange}
        placeholder="Buscar productos..."
        className="form-control"
      />
      <Table striped bordered hover responsive className="table-sm">
        <thead>
          <tr>
            <th>Imagen</th>
            <th>Marca</th>
            <th>Referencia</th>
            <th>Nombre</th>
            <th>Valor</th>
            <th>Descripción</th>
            <th>Cantidad</th>
            <th>Categoria</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {filteredProducts.map((product) => (
            <tr key={product._id}>
              <td>
                <img
                  src={`https://full-rest-api.onrender.com/uploads/${product.image}`}
                  alt={product.name}
                  style={{ width: "100px", height: "auto" }}
                />
              </td>
              <td>{product.brand}</td>
              <td>{product.reference}</td>
              <td>{product.name}</td>
              <td>{formatCurrency(product.value)}</td>
              <td>{product.description}</td>
              <td>{product.quantity}</td>
              <td>{product.category}</td>
              <td id="button">
                <Button
                  style={{ margin: "5px" }}
                  className="btn-sm"
                  variant="success"
                  onClick={() => handleShowResendModal(product)}
                >
                  <FaPaperPlane />
                </Button>
                <Button
                  style={{ margin: "5px" }}
                  className="btn-sm"
                  variant="primary"
                  onClick={() => handleShowDetailsModal(product)}
                >
                  <FaEdit />
                </Button>
                <Button
                  variant="danger"
                  style={{ margin: "5px" }}
                  className="btn-sm"
                  onClick={() => handleShowDeleteModal(product._id)}
                >
                  <FaTrash style={{ color: "white" }} />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Delete Modal */}
      <Modal show={showDeleteModal} onHide={closeDeleteModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Eliminar Servicio</Modal.Title>
        </Modal.Header>
        <Modal.Body>¿Estás seguro de que quieres eliminar este Servicio?</Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={deleteProduct}>
            Borrar <FaTrash />
          </Button>
          <Button variant="secondary" onClick={closeDeleteModal}>
            Cancelar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Resend Modal */}
      <Modal show={showResendModal} onHide={closeResendModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Reenviar Servicio</Modal.Title>
        </Modal.Header>
        <Modal.Body>¿Estás seguro de que quieres reenviar el Servicio?</Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={()=>{alert("Reenviar Mail")}}>
            Enviar <FaPaperPlane />
          </Button>
          <Button variant="secondary" onClick={closeResendModal}>
            Cancelar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Edit Details Modal */}
      <Modal size="lg" show={showDetailsModal} onHide={closeDetailsModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Editar Producto</Modal.Title>
        </Modal.Header>
        <Modal.Body className="grid-example">
          <Container>
            {selectedProduct ? (
              <Row>
                <Container >
                  <strong>{selectedProduct.name}</strong>
                  <Image
                  src={`http://localhost:3000/uploads/${selectedProduct.image}`}
                  alt={selectedProduct.name}
                  style={{ width: "100px", height: "auto" }}
                />
                </Container>
                <Col xs={12} md={6}>
                  <strong>Marca:</strong>
                  <input
                    type="text"
                    value={selectedProduct.brand}
                    onChange={({ target: { value } }) =>
                      setSelectedProduct({ ...selectedProduct, brand: value })
                    }
                    className="form-control"
                  />
                </Col>
                <Col xs={12} md={6}>
                  <strong>Valor:</strong>
                  <input
                    type="text"
                    value={formatCurrency(selectedProduct.value)}
                    onChange={({ target: { value } }) =>
                      setSelectedProduct({ ...selectedProduct, created: value })
                    }
                    className="form-control"
                  />
                </Col>
                <Col xs={12} md={6}>
                  <strong>Categoria:</strong>
                  <input
                    type="text"
                    value={selectedProduct.category}
                    onChange={({ target: { value } }) =>
                      setSelectedProduct({ ...selectedProduct, category: value })
                    }
                    className="form-control"
                  />
                </Col>
                <Col xs={12} md={6}>
                  <strong>Referencia:</strong>
                  <input
                    type="text"
                    value={selectedProduct.reference}
                    onChange={({ target: { value } }) =>
                      setSelectedProduct({ ...selectedProduct, category: value })
                    }
                    className="form-control"
                  />
                </Col>
                <Row>
                  <Col>
                    <strong>Actividad:</strong>
                    <textarea
                      className="form-control"
                      value={selectedProduct.description}
                      onChange={({ target: { value } }) =>
                        setSelectedProduct({ ...selectedProduct, description: value })
                      }
                      style={{ height: "120px" }}
                    ></textarea>
                  </Col>
                </Row>
              </Row>
            ) : (
              "No se ha seleccionado ningún producto"
            )}
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() =>{alert("Esta es ")}}>
            Guardar <FaRegSave />
          </Button>
          <Button variant="secondary" onClick={closeDetailsModal}>
            Cancelar
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

export default ListProducts;
